import { render, staticRenderFns } from "./IndexRedeemed.vue?vue&type=template&id=20df5aae&"
import script from "./IndexRedeemed.vue?vue&type=script&lang=js&"
export * from "./IndexRedeemed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports